var mobileDeliveryOptions = {
    isSelectedMobileAddress: false
}
var mobileDeliveryMethod;
var CheckoutMobileAddressJs = (function ($) {
    var $radioButtons;
    var $clickElem;
    var showHideMobileDeliveryAddress = function(target, elemSel) {
    if (target.attr("value") === mobileDeliveryMethod) {
            $(".j-checkout-address-mobile").show();
        }else{
             $(".j-checkout-address-mobile").hide();
        }
     };

    var initShowHideMobileDel = function (radioButtonsSel, elemSel) {
        var radioBSel = radioButtonsSel + " input[type='radio']";
        showHideMobileDeliveryAddress($(radioBSel + '[name=deliveryMethod]:checked'), ".j-checkout-address-mobile");
        $(radioBSel).on("click", function () {
            showHideMobileDeliveryAddress($(this), elemSel);
        });
    };

    var addClickHandlerRadioButton = function (radioButtonSel, citySel) {
        $radioButtons = $(radioButtonSel);

        $radioButtons.filter("[value='mobilefitting']").on("click", function() {
            $clickElem = $(this);
            var availableCities = $clickElem.data("available-cities");
            if ($clickElem.prop("checked") === true) {
                if (!$(citySel).val()) {
                    openNoCityAlert();
                } else if (availableCities.split(",").indexOf($(citySel).val()) < 0) {
                    openWrongCityAlert();
                } else {
                    window.THEME.$document.trigger("deliveryChange", [$(this)]);
                }

            }
        });
    };

    var openNoCityAlert = function () {
        $('.j-alert-ok-button').on('click', function () {
            jQuery.fancybox.close();
        });

        jQuery.fancybox({ 'content' : $('#j-no-city-entered-alert-mobile'), beforeClose : function() {
            $('.j-delivery-method-radio-buttons input[type=radio]:checked').prop('checked', false);
            window.THEME.$document.trigger("deliveryChange", [$(this)]);
            $(".j-checkout-address-mobile").hide();
            $('.j-checkout-invoice-details-city').trigger("focus");
        }, helpers : { overlay : { locked : false } } });
    };

    var openWrongCityAlert = function () {
        $('.j-alert-ok-button').on('click', function () {
            jQuery.fancybox.close();
        });

        jQuery.fancybox({ 'content' : $('#j-wrong-city-entered-alert-mobile'), beforeClose : function() {
            $('.j-delivery-method-radio-buttons input[type=radio]:checked').prop('checked', false);
            window.THEME.$document.trigger("deliveryChange", [$(this)]);
            $(".j-checkout-address-mobile").hide();
            $('.j-checkout-invoice-details-city').trigger("focus");
            var defaultDeliveryMethodElement = $("#defaultDeliveryMethod");
            if (defaultDeliveryMethodElement && defaultDeliveryMethodElement.val()) {
                $(".j-delivery-method-radio-buttons input[type='radio']")
                    .filter("[value='" + defaultDeliveryMethodElement.val() + "']")
                    .first()
                    .prop("checked", true).trigger("click");
            }
        }, helpers : { overlay : { locked : false } } });
    };

    return {
        initShowHideMobileDel: initShowHideMobileDel,
        addClickHandlerRadioButton: addClickHandlerRadioButton,
        showHideMobileDeliveryAddress: showHideMobileDeliveryAddress
    }
})(jQuery);

$(document).ready(function () {
    var radioButtonsSel = ".j-delivery-method-radio-buttons input[type='radio']";
    var citySel = ".j-checkout-invoice-details-city";
    if (typeof $("#mobileRadioButton") !== 'undefined' && typeof $("#mobileRadioButton").val() !== 'undefined') {
        CheckoutMobileAddressJs.addClickHandlerRadioButton(radioButtonsSel, citySel);
        mobileDeliveryMethod = $("#mobileRadioButton").val();
        CheckoutMobileAddressJs.initShowHideMobileDel(".j-delivery-method-radio-buttons", ".j-checkout-address-mobile");
    }
});